/**
 * JUWARI 定期便選択時のメイン価格連動。
 * Mikawaya V3 の購入方法選択(purchase_option / selling-plan-radio)に応じて、
 * テーマ側のメイン価格表示を選択中の Selling Plan の実データ
 * (variant.selling_plan_allocations を Liquid で JSON 埋め込みしたもの)に
 * 切り替える。単品に戻した場合は必ず通常価格へ戻す。
 *
 * - 価格は Mikawaya の DOM 文字列からは一切取得しない
 * - 判定に使う selling_plan は「今すぐ購入」(cartCreate)が読むのと同じ
 *   hidden input[name="selling_plan"] なので、表示価格と cartCreate に渡る
 *   プランは構造的に一致する
 * - 購入ロジック・カート追加・Mikawaya の処理には触れない(表示のみ)
 */
if (typeof window.JuwariSubscriptionPrice === 'undefined') {
  window.JuwariSubscriptionPrice = (function () {
    function readData(dataEl) {
      try {
        return JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error('[JuwariSubscriptionPrice] 価格データの解析に失敗しました', e);
        return null;
      }
    }

    function currentSellingPlanId() {
      const input = document.querySelector('input[name="selling_plan"]');
      if (!input) return null;
      const value = String(input.value || '').trim();
      return value === '' ? null : value;
    }

    function sync() {
      const dataEl = document.querySelector('[data-juwari-price-data]');
      if (!dataEl) return;

      const sectionId = dataEl.getAttribute('data-section-id');
      const priceRoot = document.getElementById('price-' + sectionId);
      if (!priceRoot) return;

      const data = readData(dataEl);
      if (!data || !data.variants) return;

      const form = document.getElementById('product-form-' + sectionId);
      const variantInput = form ? form.querySelector('[name="id"]') : null;
      const variantId = variantInput ? String(variantInput.value) : null;
      const variant = variantId ? data.variants[variantId] : null;
      if (!variant) return;

      const planId = currentSellingPlanId();
      let formatted = variant.price_formatted;
      if (planId && variant.allocations && variant.allocations[planId]) {
        formatted = variant.allocations[planId].price_formatted;
      }

      const target = priceRoot.querySelector('.price__regular .price-item--regular');
      if (target && target.textContent.trim() !== formatted) {
        target.textContent = formatted;
      }
    }

    // Mikawaya のラジオ操作後、hidden input への反映を待ってから同期する
    function delayedSync() {
      setTimeout(sync, 150);
      setTimeout(sync, 500);
    }

    document.addEventListener('change', function (e) {
      const name = e.target && e.target.name;
      if (name === 'purchase_option' || name === 'selling-plan-radio' || name === 'selling_plan' || name === 'id') {
        delayedSync();
      }
    });

    // 初期表示・bfcache 復元時も選択状態に合わせる
    window.addEventListener('pageshow', function () {
      setTimeout(sync, 300);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }

    return { sync: sync };
  })();
}
